function base64toFile(base64String, filename, mimeType) {
  const byteString = atob(base64String.split(',')[1])
  const ab = new ArrayBuffer(byteString.length)
  const ia = new Uint8Array(ab)
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }
  const file = new File([ab], filename, { type: mimeType })
  console.log(file)
  return file
}
export default base64toFile
